import { BindingRecordFormEnum } from '@types'
import { moduleId } from '@configs'

export const DateRangeOptions = [
  { label: '当月', value: 'tmonth' },
  { label: '近7天', value: 'l7d' },
  { label: '近15天', value: 'l15d' },
  { label: '近30天', value: 'l30d' },
  { label: '近60天', value: 'l60d' },
]

export const BindingRecordFormTextMapping: Record<BindingRecordFormEnum, string> = {
  [BindingRecordFormEnum.PRIVATE_AREA]: '私域',
  [BindingRecordFormEnum.SMS]: '短信',
}

export const ModuleNameMapping = {
  [moduleId.MID_LONG_TAIL_ID]: '销售转化一云电销',
  [moduleId.COC_TURN_ID]: '销售转化-官网个人转化',
  [moduleId.REBATE_ID]: '销售转化一腾讯云伙伴',
  [moduleId.SDR_CLEAN]: '清洗-市场部',
  [moduleId.MID_LONG_TAIL_CLEAN_ID]: '清洗-商机管理中台',
  [moduleId.TENCENT_MEETING_ID]: '销售转化-腾讯会议伙伴',
  [moduleId.COC_STUDY_ID]: '调研-官网',
  [moduleId.SASS_ID]: '销售转化-SaaS电销',
  [moduleId.SAAS_CHANNEL]: '销售转化-SaaS伙伴',
}

export const CommunicateTypeOptions = [
  {
    key: 'phone',
    name: '电话',
    value: 'phone',
  },
  {
    key: 'msg',
    name: '短信',
    value: 'msg',
  },
  {
    key: 'email',
    name: '邮件',
    value: 'email',
  },
  {
    key: 'im',
    name: 'IM',
    value: 'im',
  },
  {
    key: 'other',
    name: '其他',
    value: 'other',
  },
]
